import React, { useState } from "react";
import styles from "../Purifier/Purifier.module.css";
import { Link } from "react-router-dom";
import Purifier_Data from "../../Data/RO-landing.json";

const Purifiers = () => {
  let Purifier_carousal = Purifier_Data[0]?.carousel;

  return (
    <>
      <div className={styles.container}>
        {Purifier_carousal.cardItems.map((data, index) => {
          return (
            <>
              <div className={styles.carousal}>
                <img src={data.imgUrl} alt={data.displayName} />
                <h5>{data.displayName}</h5>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default Purifiers;
